var $ = require( 'jquery' );

/**
 * Main menu
 */
function init() {
	var $toggleBtn = $( '.js-main-navigation__toggle' );
	var $mainNavigation = $( '.js-main-navigation' );

	$toggleBtn.click( function ( e ) {
		e.preventDefault();
		$mainNavigation.toggleClass( 'is-expanded' );
	} );
}

module.exports = {
	init: init,
};



//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/src/js/main-menu.js
// module id = 3
// module chunks = 0